import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AgentUsage } from 'src/app/@core/services/ai/ai-assistant.service';

/**
 * Détail de consommation d'un tour ou d'une session : tokens et coût estimatif
 * ventilés en entrée / (raisonnement + sortie) / total.
 *
 * - `usage` absent (utilisateur non autorisé) : rien n'est affiché.
 * - `usage.cost` à `null` (tarif non résoluble) : seuls les tokens sont affichés.
 *
 * Le raisonnement n'a pas de tarif dédié (facturé avec l'output) : ses tokens
 * sont regroupés avec la sortie sous un seul prix (`cost.output`).
 * Les recherches sur internet sont un poste à part, sans tokens, affiché seulement
 * quand il est non nul : `cost.total` les inclut déjà.
 */
@Component({
    selector: 'app-assistant-usage',
    standalone: true,
    imports: [
        CommonModule,
    ],
    templateUrl: './assistant-usage.component.html',
})
export class AssistantUsageComponent {

    @Input() usage: AgentUsage | null = null;
    /** Libellé optionnel affiché au-dessus du détail (ex. « Total conversation »). */
    @Input() label: string | null = null;
}
